export default __webpack_public_path__ + "static/media/arrow.35160f6b.svg";